import { Injectable } from '@angular/core';
import { ApiService } from '../../../../shared/services/api/api.service';
import { Observable } from 'rxjs';
import { IPagination } from '../../../../shared/services/api/interface/pagination.interface';
import { IAnnouncement } from '../models/announcement';


@Injectable({
  providedIn: 'root',
})
export class AnnouncementReadStatusService {
  constructor(private readonly apiService: ApiService) {}

  getList() {
    return this.apiService.get<any>('announcement-read-status');
  }

  getFilter(event: any, filter: any): Observable<IPagination> {
    return this.apiService.getFilter<IPagination>(
      `announcement-read-status/announcement-read-status-filter-list`,
      { event: event, filter: filter }
    );
  }

  create(menu: any): Observable<IAnnouncement> {
    return this.apiService.post<any>('announcement-read-status/create', menu);
  }



  delete(id: number): Observable<any> {
    return this.apiService.delete<any>(`announcement-to-publish/delete/${id}`);
  }
}
